import { cn } from '@exam-room/utils';

import { Form } from '../base';
import MathRenderer from '../math-renderer';

export interface ChoiceProps {
  name: string;
  value: string;
  label: string;
  index: number;
  showElimination?: boolean;
  eliminated?: boolean;
  onSelect?: () => void;
}

function ChoiceLabel({ label }: { label: string }) {
  return <MathRenderer content={label} className='w-full text-start' />;
}

export default function Choice({
  name,
  value,
  label,
  index,
  showElimination,
  eliminated,
  onSelect,
}: ChoiceProps) {
  const q = name.split('.')[0];

  const shouldShowElimination = showElimination && eliminated;

  return (
    <div className='flex w-full gap-2'>
      <div className='relative flex-1'>
        <Form.Radio
          id={`${name}.${index}`}
          data-testid={`exam-item-choice-${index + 1}`}
          name={name}
          value={String(value)}
          onClick={onSelect}
        >
          {(isChecked) => (
            <div
              className={cn(
                'flex w-full items-center justify-start gap-4',
                shouldShowElimination && 'opacity-50',
              )}
            >
              <div
                className={cn(
                  'ignore-font-scale flex aspect-square h-5 grow items-center justify-center rounded-full border-2 border-gray-400 text-center',
                  isChecked && 'border-primary text-primary',
                )}
              >
                {isChecked ? <div className='bg-primary size-2.5 rounded-full' /> : null}
              </div>
              {index + 1}.
              <ChoiceLabel label={label} />
            </div>
          )}
        </Form.Radio>
        <div
          className={cn(
            'pointer-events-none invisible absolute top-1/2 left-[-6px] w-[calc(100%+12px)] border-t-2 border-black',
            shouldShowElimination && 'visible',
          )}
        />
      </div>
      {showElimination ? (
        <Form.CustomCheckbox name={`${q}.eliminated.${index}`} id={`${q}.eliminated.${index}`}>
          {({ open }) => (
            <div className='grid w-12 place-items-center'>
              {open ? (
                <p className='ignore-font-scale underline'>Undo</p>
              ) : (
                <div className='ignore-font-scale relative grid h-6 w-6 cursor-pointer place-items-center rounded-full border border-black'>
                  <div className='absolute top-1/2 left-[-1] w-8 border-t-2 border-black' />
                  {index + 1}
                </div>
              )}
            </div>
          )}
        </Form.CustomCheckbox>
      ) : null}
    </div>
  );
}
